<template>
  <div>
    <modal></modal>
    <default-header/>
    <router-view class="router-view" :key="$route.fullPath"/>
    <default-footer/>
  </div>
</template>
<script>
import DefaultHeader from './DefaultHeader.vue'
import DefaultFooter from './DefaultFooter.vue'
import Modal from '@/components/Modal'

export default {
  name: 'DefaultLayout',
  components: {
    DefaultHeader,
    DefaultFooter,
    Modal
  }
}
</script>

<style lang="scss">
.router-view {
  margin-top: 105px;

  @media screen and (max-width: 1199px) {
    margin-top: 82px;
  }

  @media screen and (max-width: 767px) {
    margin-top: 59px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/DefaultLayout.vue